/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Button, List, ListItem, ListItemIcon, Paper, Typography,
} from '@material-ui/core';
import clsx from 'clsx';
import parse from 'html-react-parser';
import moment from 'moment';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import { Send } from '@material-ui/icons';
import webinaireImg from '../img/webinaire_1.jpg';
import webinaireServices from '../../redux/services/webinaireServices';
import { Loading } from '../../helpers/utils';
import { useWebinaireListStyles, formatDurationMinutes } from './webinaireStyles';

const bgStyle = {
  backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.94)), url(${webinaireImg})`,
};

const UpcomingWebinaire = ({ userData, setSuccessSnackBar, setErrorSnackBar }) => {
  const classes = useWebinaireListStyles();
  const [webinaires, setWebinaires] = useState([]);
  const [loading, setLoading] = useState(true);

  const getWebinairesData = async () => {
    const webinaireRes = await webinaireServices.getWebinaires();
    if (webinaireRes && webinaireRes.length > 0) {
      const newWebinaires = webinaireRes.filter((webinaire) => new Date(webinaire.start) >= new Date());
      setWebinaires(newWebinaires);
      setLoading(false);
    } else {
      setErrorSnackBar({ code: 400, message: 'Failed to fetch webinaires', severity: 'error' });
      setLoading(false);
    }
  };

  useEffect(() => {
    getWebinairesData();
  }, []);

  const handleReservation = async (data) => {
    const body = {
      meetingId: data.meetingId,
      webinaireId: data._id,
      firstname: userData.firstname,
      lastname: userData.name,
      email: userData.email,
      userId: userData._id,
    };

    const registrationRes = await webinaireServices.addRegistrant(body);
    if (registrationRes && registrationRes._id) {
      const cpyWebinaires = [...webinaires];
      cpyWebinaires.forEach((webinaire) => {
        if (webinaire._id === registrationRes._id) {
          webinaire.registered = registrationRes.registered;
        }
      });
      setWebinaires(cpyWebinaires);
      setSuccessSnackBar({ severity: 'success', message: 'Inscription effectuée' });
    } else {
      setErrorSnackBar({ code: 400, severity: 'error', message: 'Echec de l\'inscription' });
    }
  };

  return (
    <div
      className={clsx(classes.page, classes.pageWithBg)}
      style={bgStyle}
    >
      {!loading ? (
        <>
          <Alert
            role="alert"
            severity="info"
          >
            <AlertTitle>Informations</AlertTitle>
            <List dense>
              <ListItem>
                <ListItemIcon>
                  <Send style={{ width: '18px' }} />
                </ListItemIcon>
                <Typography component="p" variant="body2">Il n&apos;est pas nécessaire de vous inscrire à un webinaire pour pouvoir accéder au replay.</Typography>
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <Send style={{ width: '18px' }} />
                </ListItemIcon>
                <Typography component="p" variant="body2">Vous pourrez accéder à vos webinaires une fois inscrit depuis l&apos;onglet « Mes webinaires ».</Typography>
              </ListItem>
            </List>
          </Alert>
          {webinaires.length > 0 ? (
            webinaires.map((webinaire) => (
              <Paper
                key={webinaire._id}
                className={classes.card}
                elevation={2}
              >
                <div className={classes.cardHeaderRow}>
                  <Typography className={classes.meta} component="p" variant="body2">
                    {moment(webinaire.start).format('DD/MM/YYYY [à] HH:mm')}
                  </Typography>
                  <Typography className={classes.meta} component="p" variant="body2">
                    {`Places restantes : ${Math.max(0, webinaire.places - webinaire.registered.length)}`}
                  </Typography>
                </div>
                <Typography className={classes.meta} component="p" variant="body2">
                  {`Durée : ${formatDurationMinutes(webinaire.duration)}`}
                </Typography>
                <Typography component="h2" variant="h6" className={classes.title}>
                  {webinaire.topic}
                </Typography>
                <Typography component="div" variant="body2" align="justify">{parse(webinaire.blurb)}</Typography>
                <div className={classes.actions}>
                  <Button
                    onClick={() => handleReservation(webinaire)}
                    variant="contained"
                    color="primary"
                    disableElevation
                    size="small"
                    disabled={webinaire.registered.includes(userData._id) || webinaire.registered.length === webinaire.places}
                    aria-label={webinaire.registered.includes(userData._id) ? `Webinaire ${webinaire.topic} déjà réservé` : `Réserver le webinaire ${webinaire.topic}`}
                  >
                    {webinaire.registered.includes(userData._id) ? 'Réservé' : 'Réserver'}
                  </Button>
                </div>
              </Paper>
            ))
          ) : (
            <div className={classes.emptyState}>
              <Typography component="h2" variant="h6" className={classes.emptyTitle}>
                Aucun webinaire programmé pour le moment.
              </Typography>
              <Typography variant="body2" className={classes.emptyHint}>
                Revenez plus tard ou consultez les replays disponibles.
              </Typography>
            </div>
          )}
        </>
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default UpcomingWebinaire;
